const post = async (url, bodyData, onSuccess, onFail) => {

    try {

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(bodyData)
        });

        const data = await response.json();

        if(!response.ok) {
            if(typeof onFail === "function") {
                onFail(response, data);
                return;
            } else {
                return;
            }
        }

        if(typeof onSuccess === "function") {
            onSuccess(response, data);
        }

    } catch (err) {
        if (typeof onFail === "function") {
            onFail();
        }
    }

}; export default post;